module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }